// @flow

import React, { useMemo, type Node } from 'react'
import { useSelector } from 'react-redux'
import { isNotEmpty } from 'ramda-adjunct'

import { getServiceProviderId } from '@alphaott/app-core/selectors'
import { getBrandId, isOpenPanelEnabled, getOpenPanelConfig } from '@alphaott/app-main/selectors'

import { OpenPanelContext } from './OpenPanelContext'
import { createOpenPanel, type Source } from '../../utils'

type AppAnalyticsProviderProps = {
  source: Source,
  children: Node,
}

// eslint-disable-next-line complexity
export const OpenPanelProvider = ({ source, children }: AppAnalyticsProviderProps) => {
  const brandId = useSelector(getBrandId)
  const serviceProviderId = useSelector(getServiceProviderId)
  const isEnabled = useSelector(isOpenPanelEnabled)
  const openPanelConfig = useSelector(getOpenPanelConfig)

  const hasConfig = isNotEmpty(openPanelConfig?.apiUrl) && isNotEmpty(openPanelConfig?.clientId)

  const config = {
    ...openPanelConfig,
    disabled: !isEnabled || !hasConfig,
  }

  const appContext = {
    source,
    brandId,
    serviceProviderId,
  }

  // eslint-disable-next-line arrow-body-style
  const instance = useMemo(() => {
    return createOpenPanel(config, appContext)
  }, [openPanelConfig]) // eslint-disable-line react-hooks/exhaustive-deps

  return <OpenPanelContext.Provider value={instance}>{children}</OpenPanelContext.Provider>
}

export default OpenPanelProvider
